import { COLORS } from '@btime/constants'
import { SyncLoader, PuffLoader } from 'react-spinners'
import React from 'react'

import { Absolute, Relative } from './Position'
import Center from './Center'

export const SpinnerLoading = ({ color, size }) => (
  <Center>
    <PuffLoader color={color || COLORS.dark5} size={size || 18} width={1} />
  </Center>
)

const Loading = ({ color, size }) => (
  <Center>
    <SyncLoader color={color || COLORS.purple} size={size || 8} />
  </Center>
)

export const WrapLoading = ({ loading, children, bgColor, color }) => {
  if (!loading) return children

  return (
    <Relative>
      {children}
      <Absolute top={0} bottom={0} left={0} right={0} bgColor={bgColor || COLORS.lightTransparent3}>
        <Loading color={color || COLORS.blue} />
      </Absolute>
    </Relative>
  )
}

export default Loading
